import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
interface IParams {
    isFake?:boolean;
    callBack?:() => void
}
interface IProps extends IParams, RouteComponentProps{ }
const _BackButton = (props: IProps) => {
    if(props.isFake){
    return (
    <li>
        <a
            onClick={props.callBack}
            className="button-large button-transparent back-btn"
        >
            <i className="fa fa-angle-left" aria-hidden="true" />
        </a>
    </li>
    )
    }else{
        return (
        <li>
            <a
                onClick={() => {
                    props.history.goBack()}
                }
                className="button-large button-transparent back-btn"
            >
                <i className="fa fa-angle-left" aria-hidden="true" />
            </a>
        </li>)
    }
}

export const BackButton = withRouter(_BackButton);
